import React from 'react';
import { Card, Table, Button, Row, Col, Form as BSForm, Spinner } from 'react-bootstrap';
import Pagination from 'react-js-pagination';
import { PlusOutlined } from '@ant-design/icons';
import { Select } from 'antd';
import { GIOI_TINH, HOC_VI, CHUC_DANH_KH } from '@app/utils/define';
import { BaseGatewayImage } from '@app/utils/apiUrl';

const LecturerSearch = ({
    history,
    donVis,
    lecturers,
    lecturersPageIndex,
    lecturersPageSize,
    lecturersTotalItems,
    filterHoTen,
    setFilterHoTen,
    filterUsernameOrEmail,
    setFilterUsernameOrEmail,
    filterHocVi,
    setFilterHocVi,
    filterChucDanh,
    setFilterChucDanh,
    filterSoCCCD,
    setFilterSoCCCD,
    filterThanhTich,
    setFilterThanhTich,
    filterDonVi,
    setFilterDonVi,
    filterTuNam,
    setFilterTuNam,
    filterDenNam,
    setFilterDenNam,
    isAdvancedOpen,
    setIsAdvancedOpen,
    handleExecuteSearch,
    handleResetFilters,
    handleExportExcel,
    handlePageChange,
    handleToggleActive,
    isExporting
}) => {
    const currentYear = new Date().getFullYear();
    const yearsList = [];
    for (let y = currentYear + 4; y >= 2015; y--) {
        yearsList.push(y);
    }

    const formatDob = (dateStr) => {
        if (!dateStr || dateStr.startsWith('0001')) return 'Chưa cập nhật';
        try {
            const d = new Date(dateStr);
            if (isNaN(d.getTime())) return dateStr;
            const day = String(d.getDate()).padStart(2, '0');
            const month = String(d.getMonth() + 1).padStart(2, '0');
            const year = d.getFullYear();
            return `${day}/${month}/${year}`;
        } catch (e) {
            return dateStr;
        }
    };

    return (
        <Card className="shadow border-0">
            <Card.Header className="text-white d-flex justify-content-between align-items-center" style={{ backgroundColor: '#28a745' }}>
                <h5 className="mb-0">
                    <i className="fas fa-search mr-2" />Tra cứu thông tin giảng viên
                    <span 
                        className="badge badge-info ml-3 py-1 px-2 text-white" 
                        style={{ 
                            fontSize: '12px', 
                            fontWeight: 'normal', 
                            cursor: 'pointer', 
                            backgroundColor: 'rgba(255,255,255,0.2)', 
                            border: '1px solid rgba(255,255,255,0.4)' 
                        }} 
                        onClick={() => history.push('/account')}
                    >
                        Tạo tài khoản
                    </span>
                </h5>
            </Card.Header>
            <Card.Body>
                {/* Tra cứu thông tin giảng viên Form */}
                <div className="card mb-4" style={{ border: '1px solid #28a745' }}>
                    <div className="card-body bg-light text-dark p-3">
                        <Row className="mb-2">
                            <Col md={6} className="d-flex flex-column flex-md-row align-items-stretch align-items-md-center mb-2 search-form-row">
                                <span style={{ minWidth: '150px', fontWeight: '500' }} className="mb-1 mb-md-0">Họ và tên:</span>
                                <BSForm.Control
                                    type="text"
                                    placeholder="Nhập họ và tên..."
                                    value={filterHoTen}
                                    onChange={(e) => setFilterHoTen(e.target.value)}
                                    onKeyDown={(e) => e.key === 'Enter' && handleExecuteSearch()}
                                />
                            </Col>
                            <Col md={6} className="d-flex flex-column flex-md-row align-items-stretch align-items-md-center mb-2 search-form-row">
                                <span style={{ minWidth: '150px', fontWeight: '500' }} className="mb-1 mb-md-0">Username or Email:</span>
                                <BSForm.Control
                                    type="text"
                                    placeholder="Nhập username hoặc email..."
                                    value={filterUsernameOrEmail}
                                    onChange={(e) => setFilterUsernameOrEmail(e.target.value)}
                                    onKeyDown={(e) => e.key === 'Enter' && handleExecuteSearch()}
                                />
                            </Col>
                        </Row>

                        <Row className="mb-2">
                            <Col md={6} className="d-flex flex-column flex-md-row align-items-stretch align-items-md-center mb-2 search-form-row">
                                <span style={{ minWidth: '150px', fontWeight: '500' }} className="mb-1 mb-md-0">Học vị / Chức danh:</span>
                                <div className="d-flex flex-row w-100 search-form-double-input" style={{ gap: '8px' }}>
                                    <BSForm.Control
                                        as="select"
                                        value={filterHocVi}
                                        onChange={(e) => setFilterHocVi(e.target.value)}
                                        style={{ flex: 1 }}
                                    >
                                        <option value="">Chọn trình độ</option>
                                        {HOC_VI.map(o => (
                                            <option key={o.value} value={o.value}>{o.label}</option>
                                        ))}
                                    </BSForm.Control>
                                    <BSForm.Control
                                        as="select"
                                        value={filterChucDanh}
                                        onChange={(e) => setFilterChucDanh(e.target.value)}
                                        style={{ flex: 1 }}
                                    >
                                        <option value="">Chọn chức danh</option>
                                        {CHUC_DANH_KH.map(o => (
                                            <option key={o.value} value={o.value}>{o.label}</option>
                                        ))}
                                    </BSForm.Control>
                                </div>
                            </Col>
                            <Col md={6} className="d-flex flex-column flex-md-row align-items-stretch align-items-md-center mb-2 search-form-row">
                                <span style={{ minWidth: '150px', fontWeight: '500' }} className="mb-1 mb-md-0">Số CCCD:</span>
                                <BSForm.Control
                                    type="text"
                                    placeholder="Nhập số CCCD..."
                                    value={filterSoCCCD}
                                    onChange={(e) => setFilterSoCCCD(e.target.value)}
                                    onKeyDown={(e) => e.key === 'Enter' && handleExecuteSearch()}
                                />
                            </Col>
                        </Row>

                        {isAdvancedOpen && (
                            <>
                                <Row className="mb-2">
                                    <Col md={6} className="d-flex flex-column flex-md-row align-items-stretch align-items-md-center mb-2 search-form-row">
                                        <span style={{ minWidth: '150px', fontWeight: '500' }} className="mb-1 mb-md-0">Thành tích NCKH, đào tạo:</span>
                                        <BSForm.Control
                                            as="select"
                                            value={filterThanhTich}
                                            onChange={(e) => setFilterThanhTich(e.target.value)}
                                        >
                                            <option value="">Chọn tất cả</option>
                                            <option value="CoThanhTich">Có thành tích</option>
                                            <option value="KhongThanhTich">Không có thành tích</option>
                                        </BSForm.Control>
                                    </Col>
                                    <Col md={6} className="d-flex flex-column flex-md-row align-items-stretch align-items-md-center mb-2 search-form-row">
                                        <span style={{ minWidth: '150px', fontWeight: '500' }} className="mb-1 mb-md-0">Khoa / Phòng:</span>
                                        <Select
                                            mode="multiple"
                                            allowClear
                                            style={{ width: '100%' }}
                                            placeholder="Tất cả khoa phòng"
                                            value={filterDonVi || []}
                                            onChange={(val) => setFilterDonVi(val)}
                                            options={donVis.map(u => ({ label: u.tenDonVi, value: u.id }))}
                                            filterOption={(input, option) =>
                                                (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
                                            }
                                        />
                                    </Col>
                                </Row>

                                <Row className="mb-2">
                                    <Col md={6} className="d-flex flex-column flex-md-row align-items-stretch align-items-md-center mb-2 search-form-row">
                                        <span style={{ minWidth: '150px', fontWeight: '500' }} className="mb-1 mb-md-0">Thời gian:</span>
                                        <div className="d-flex flex-row w-100 search-form-double-input" style={{ gap: '8px' }}>
                                            <BSForm.Control
                                                type="number"
                                                placeholder="Từ năm"
                                                value={filterTuNam || ''}
                                                onChange={(e) => setFilterTuNam(e.target.value)}
                                                style={{ flex: 1 }}
                                                min={1900}
                                                max={2100}
                                            />
                                            <BSForm.Control
                                                type="number"
                                                placeholder="Đến năm"
                                                value={filterDenNam || ''}
                                                onChange={(e) => setFilterDenNam(e.target.value)}
                                                style={{ flex: 1 }}
                                                min={1900}
                                                max={2100}
                                            />
                                        </div>
                                    </Col>
                                </Row>
                            </>
                        )}

                        <div className="d-flex flex-column flex-md-row justify-content-between align-items-stretch align-items-md-center mt-3 pt-2 border-top gap-2">
                            <div className="d-flex flex-column flex-md-row gap-2 w-100 btn-desktop-auto">
                                <Button variant="primary" onClick={handleExecuteSearch} className="w-100 btn-desktop-auto px-4">
                                    <i className="fas fa-search mr-2" />Tra cứu
                                </Button>
                                <Button variant="danger" onClick={handleResetFilters} className="w-100 btn-desktop-auto px-3">
                                    <i className="fas fa-undo mr-2" />Làm mới bộ lọc
                                </Button>
                                <Button 
                                    variant="success" 
                                    onClick={handleExportExcel} 
                                    className="w-100 btn-desktop-auto"
                                    disabled={isExporting}
                                >
                                    {isExporting ? (
                                        <Spinner animation="border" size="sm" className="mr-2" />
                                    ) : (
                                        <i className="fas fa-file-excel mr-2" />
                                    )}
                                    Xuất Excel báo cáo
                                </Button>
                            </div>
                            <Button
                                variant="outline-success"
                                onClick={() => setIsAdvancedOpen(!isAdvancedOpen)}
                                className="d-flex align-items-center justify-content-center w-100 btn-desktop-auto mt-2 mt-md-0 px-4"
                            >
                                <i className={`fas fa-chevron-${isAdvancedOpen ? 'up' : 'down'} mr-2`} />
                                Tìm kiếm Nâng cao
                            </Button>
                        </div>
                    </div>
                </div>

                <Table id="table-lecturers" striped bordered hover responsive>
                    <thead className="bg-light">
                        <tr className="text-center align-middle" style={{ fontSize: '13px' }}>
                            <th style={{ width: '80px' }}>#</th>
                            <th style={{ width: '70px' }}></th>
                            <th>Họ và tên</th>
                            <th>Ngày sinh</th>
                            <th>Giới tính</th>
                            <th>Thông tin</th>
                            <th>Chức vụ</th>
                            <th>Đơn vị công tác</th>
                            <th>Hoạt động NCKH</th>
                            <th>Hoạt động đào tạo</th>
                            <th style={{ width: '130px' }}>Thao tác</th>
                        </tr>
                    </thead>
                    <tbody>
                        {lecturers.map((l, idx) => (
                            <tr key={l.id}>
                                <td className="text-center align-middle">
                                    <div className="font-weight-bold">{idx + 1 + (lecturersPageIndex - 1) * lecturersPageSize}</div>
                                    <div className="text-muted" style={{ fontSize: '11px', marginTop: '4px' }}>ID: {l.maNhanVien || 'N/A'}</div>
                                </td>
                                <td className="text-center align-middle">
                                    {l.hinhAnh ? (
                                        <img
                                            src={l.hinhAnh.startsWith('http') ? l.hinhAnh : BaseGatewayImage + (l.hinhAnh.startsWith('/') ? '' : '/') + l.hinhAnh}
                                            alt="avatar"
                                            className="rounded-circle border"
                                            style={{ width: '45px', height: '45px', objectFit: 'cover' }}
                                        />
                                    ) : (
                                        <div 
                                            className="rounded-circle border bg-secondary text-white d-flex align-items-center justify-content-center mx-auto"
                                            style={{ width: '45px', height: '45px', fontSize: '18px' }}
                                        >
                                            <i className="fas fa-user-tie" />
                                        </div>
                                    )}
                                </td>
                                <td className="align-middle">
                                    <div className="font-weight-bold">
                                        <span
                                            onClick={() => history.push(`/profile-cv/${l.id}`)}
                                            style={{ color: '#0056b3', cursor: 'pointer', textDecoration: 'none' }}
                                            onMouseEnter={(e) => e.target.style.textDecoration = 'underline'}
                                            onMouseLeave={(e) => e.target.style.textDecoration = 'none'}
                                        >
                                            {l.hoTen}
                                        </span>
                                    </div>
                                    <div className="text-muted" style={{ fontSize: '12px' }}>
                                        Username: {l.username || 'Chưa liên kết'}
                                    </div>
                                    <div>
                                        <span
                                            onClick={() => {
                                                const iframeId = `print-iframe-${l.id}`;
                                                let iframe = document.getElementById(iframeId);
                                                if (iframe) {
                                                    iframe.remove();
                                                }
                                                iframe = document.createElement('iframe');
                                                iframe.id = iframeId;
                                                iframe.style.position = 'absolute';
                                                iframe.style.width = '0px';
                                                iframe.style.height = '0px';
                                                iframe.style.border = 'none';
                                                iframe.style.left = '-9999px';
                                                iframe.style.top = '-9999px';
                                                iframe.src = `/profile-cv/${l.id}?print=v2`;
                                                document.body.appendChild(iframe);
                                                
                                                // Clean up the iframe after printing is completed
                                                setTimeout(() => {
                                                    const frame = document.getElementById(iframeId);
                                                    if (frame) frame.remove();
                                                }, 20000);
                                            }}
                                            style={{ color: '#0056b3', fontSize: '12px', cursor: 'pointer', textDecoration: 'underline' }}
                                        >
                                            In hồ sơ V2
                                        </span>
                                    </div>
                                </td>
                                <td className="text-center align-middle">{formatDob(l.ngaySinh)}</td>
                                <td className="text-center align-middle">
                                    {GIOI_TINH.find(o => o.value === l.gioiTinh)?.label || 'Chưa rõ'}
                                </td>
                                <td className="align-middle" style={{ fontSize: '12px' }}>
                                    <div>CCCD: {l.soCMND_CCCD || 'Chưa cập nhật'}</div>
                                    <div>Email: {l.emailCongViec || 'Chưa cập nhật'}</div>
                                    <div>SĐT: {l.dienThoaiDiDong || 'Chưa cập nhật'}</div>
                                    <div className="text-muted italic" style={{ fontSize: '11px' }}>Cập nhật: {formatDob(l.p_NGAYCAPNHAT || l.p_NGAYTAO)}</div>
                                </td>
                                <td className="align-middle">{l.chucVu || 'Chưa cập nhật'}</td>
                                <td className="align-middle">{l.tenDonVi || l.tenDonViTuNhap || 'Chưa cập nhật'}</td>
                                <td className="align-middle" style={{ fontSize: '12px' }}>
                                    <div className="d-flex justify-content-between">
                                        <span className="mr-3">CB QT:</span>
                                        <strong>{l.soBaiBaoQuocTe || 0}</strong>
                                    </div>
                                    <div className="d-flex justify-content-between">
                                        <span className="mr-3">CB TrN:</span>
                                        <strong>{l.soBaiBaoTrongNuoc || 0}</strong>
                                    </div>
                                    <div className="d-flex justify-content-between">
                                        <span className="mr-3">NV KHCN:</span>
                                        <strong>{l.soDeTai || 0}</strong>
                                    </div>
                                    <div className="d-flex justify-content-between">
                                        <span className="mr-3">SC, GPHI:</span>
                                        <strong>{l.soSangChe || 0}</strong>
                                    </div>
                                </td>
                                <td className="align-middle" style={{ fontSize: '12px' }}>
                                    <div className="d-flex justify-content-between">
                                        <span className="mr-3">Tổng số sách:</span>
                                        <strong>{l.soSach || 0}</strong>
                                    </div>
                                    <div className="d-flex justify-content-between">
                                        <span className="mr-3">Sách CK:</span>
                                        <strong>{l.soSachChuyenKhao || 0}</strong>
                                    </div>
                                    <div className="d-flex justify-content-between">
                                        <span className="mr-3">Sách GT:</span>
                                        <strong>{l.soSachGiaoTrinh || 0}</strong>
                                    </div>
                                    <div className="d-flex justify-content-between">
                                        <span className="mr-3">NCS:</span>
                                        <strong>{l.soHuongDanNcs || 0}</strong>
                                    </div>
                                    <div className="d-flex justify-content-between">
                                        <span className="mr-3">Học viên:</span>
                                        <strong>{l.soHuongDanHv || 0}</strong>
                                    </div>
                                </td>
                                <td className="text-center align-middle">
                                    <div className="d-flex justify-content-center align-items-center gap-2">
                                        <button
                                            type="button"
                                            className="btn btn-outline-success btn-sm rounded-circle d-flex align-items-center justify-content-center"
                                            style={{ width: '32px', height: '32px', border: '1px solid #28a745', background: 'transparent' }}
                                            title="Xem & Duyệt hồ sơ"
                                            onClick={() => history.push(`/profile-cv/${l.id}`)}
                                        >
                                            <i className="far fa-eye" style={{ color: '#28a745' }} />
                                        </button>
                                        <button
                                            type="button"
                                            className="btn btn-outline-success btn-sm rounded-circle d-flex align-items-center justify-content-center"
                                            style={{ width: '32px', height: '32px', border: '1px solid #28a745', background: 'transparent' }}
                                            title="Sửa lý lịch khoa học"
                                            onClick={() => history.push(`/nhan-vien/${l.id}`)}
                                        >
                                            <i className="fas fa-edit" style={{ color: '#28a745' }} />
                                        </button>
                                        <button
                                            type="button"
                                            className={`btn btn-sm rounded-circle d-flex align-items-center justify-content-center ${l.isActive ? 'btn-outline-success' : 'btn-outline-danger'}`}
                                            style={{ width: '32px', height: '32px', border: l.isActive ? '1px solid #28a745' : '1px solid #dc3545', background: 'transparent' }}
                                            title={l.isActive ? "Khóa giảng viên" : "Mở khóa giảng viên"}
                                            onClick={() => handleToggleActive(l)}
                                        >
                                            <i 
                                                className={l.isActive ? "fas fa-unlock" : "fas fa-lock"} 
                                                style={{ color: l.isActive ? '#28a745' : '#dc3545' }} 
                                            />
                                        </button>
                                    </div>
                                </td>
                            </tr>
                        ))}
                        {lecturers.length === 0 && (
                            <tr>
                                <td colSpan={11} className="text-center text-muted">Không tìm thấy giảng viên nào phù hợp</td>
                            </tr>
                        )}
                    </tbody>
                </Table>

                {lecturersTotalItems > lecturersPageSize && (
                    <div className="d-flex justify-content-end mt-3">
                        <Pagination
                            itemClass="page-item"
                            linkClass="page-link"
                            innerClass="pagination pagination-sm no-margin"
                            activePage={lecturersPageIndex}
                            itemsCountPerPage={lecturersPageSize}
                            totalItemsCount={lecturersTotalItems}
                            pageRangeDisplayed={5}
                            onChange={handlePageChange}
                        />
                    </div>
                )}
            </Card.Body>
        </Card>
    );
};

export default LecturerSearch;
